/**
 * Adjust pictures.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */

export function adjustPictureAttributions() {
  const pictures = document.querySelectorAll(
    'picture[data-attribution]',
  );

  pictures.forEach((picture) => {
    const attribution = picture.querySelector('.picture-attribution');

    if (!(attribution instanceof HTMLElement)) {
      return;
    }

    const attributionHeight = attribution.offsetHeight;

    attribution.style.top = 'initial';
    attribution.style.bottom = attributionHeight + 'px';
    attribution.style.left = attributionHeight / 2 + 'px';
  });
}
